import { flow, isEqual, map } from 'lodash/fp';

import getFutureDate from '../../utils/get-future-date';
import getSaleableProductIds from '../../utils/get-saleable-product-ids';
import PriceService from '.';
import ProductService from '../product';

// @ts-expect-error - Automatic, Please fix when editing this file
const componentDidMount = ({ actions, customer, products, useFutureEffectiveDate }) =>
  flow(
    (productIds) => ProductService.getProducts(products, productIds),
    (productsArray) => ProductService.filterAvailableProducts(productsArray, customer),
    map('id'),
    (productIdsToLoad) =>
      actions.price.load(productIdsToLoad, customer, { date: getFutureDate(useFutureEffectiveDate) }),
  )(getSaleableProductIds());

// @ts-expect-error - Automatic, Please fix when editing this file
const componentWillReceiveProps = (thisProps, nextProps) => {
  const thisDate = getFutureDate(thisProps.useFutureEffectiveDate);
  const nextDate = getFutureDate(nextProps.useFutureEffectiveDate);

  // Load prices for available products if the prop change could change pricing.
  const customerChange =
    PriceService.getKey('', thisProps.customer, { date: thisDate }) !==
    PriceService.getKey('', nextProps.customer, { date: nextDate });

  const changedProducts = !isEqual(thisProps.products, nextProps.products);

  if (customerChange || changedProducts) {
    const { customer, products, useFutureEffectiveDate } = nextProps;
    const { actions } = thisProps; // Not sure why this isn’t from next props
    componentDidMount({ actions, customer, products, useFutureEffectiveDate });
  }
};

export default {
  componentDidMount,
  componentWillReceiveProps,
};
